// The end date of a flow sample rate is a day in the user's local time: « until 15/12 » keeps the
// rate through 15/12. The API stores an instant (`until`), from which the rate no longer applies:
// the start of the next local day.

const pad = (n) => String(n).padStart(2, "0");

/** A Date (or date string) as "YYYY-MM-DD" in local time. */
export function localDateString(value) {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** "2026-12-15" → the ISO instant of the start of 16/12, local time. */
export function untilInstantForLastDay(lastDay) {
  const [y, m, d] = localDateString(lastDay).split("-").map(Number);
  return new Date(y, m - 1, d + 1).toISOString();
}

/** The stored `until` instant → the last local day ("YYYY-MM-DD") on which the rate applies. */
export function lastDayForUntilInstant(until) {
  return localDateString(new Date(new Date(until).getTime() - 1));
}

/** "2026-12-15" → that local day, formatted for the user's locale. */
export function formatLocalDay(day) {
  const [y, m, d] = localDateString(day).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString();
}

/** Whether the rate has ended (its `until` instant is not in the future). */
export function hasEnded(until, now = new Date()) {
  return until != null && new Date(until).getTime() <= now.getTime();
}
